

import '../App.css'

import { motion } from "framer-motion"

import React, { useState, useEffect } from 'react';

import exit from "../asstes/dashboard/exit.png"




function CancelDetailOverlay({ anime, order, close , cancelOrder }) {

    return(

        order != null ?
        <motion.div className="select-transporter-overlay bold"
            initial={{ scale: 0, opacity: 0, display: "none" }}
            animate={anime ? { scale: 1, display: "flex", opacity: 1 } : { scale: 0.5, opacity: 0, transition: { ease: "easeInOut" } }}
            exit={{ display: "none" }}
            onClick={(event) => {
                event.preventDefault();
            }}
        >
            <div className="select-transporter-container" id="select-transporter"
                onClick={(event) => {
                    event.preventDefault();
                }}
            >
                <p><b>Confirmation</b></p>
                
                <p>Do You Want to Cancel this Order [ <span>{order.id}</span> ] ?</p>

                <div className="conf-actions">
                    <div className="conf-action"
                        onClick={() => {
                            
                        cancelOrder(order.id);
                        close()
                        }}
                    >
                        <p>Confirm</p>
                    </div>
                    <div className="conf-action"
                        onClick={() => {
                            close()
                        }}
                    >
                        <p>Cancel</p>
                    </div>
                </div>

            </div>
        </motion.div>

        :
        <div></div>
    )
}

export default CancelDetailOverlay;